<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Renewed Devices" />
 
		<div class="container-fluid">

			<div class="card">
				<div class="card-body">
		
					<div class="col-md-12 project-list filter-sort">
						<div class="row">

							<div class="col-md-4 d-flex align-items-end gap-3">
								<div>
									<label class="control-label d-block">Total Devices:</label>
									<span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
								</div>
								<button type="button" class="btn btn-success" @click="downloadRenewedDevicesExcel()" :disabled="!start_date || !end_date || excel_loading">
									{{ excel_loading ? 'Exporting...' : 'Export Excel' }}
								</button>
							</div>

							<div class="col-md-2">
								<label class="control-label">Renewal Type:</label>
								<select class="form-select" v-model="renewal_type" @change="fetchRenewedDevices()">
									<option value="">All Types</option>
									<option value="1">Normal</option>
									<option value="2">SIM Change</option>
									<option value="3">Replacement</option>
									<option value="4">Noraml SIM Change</option>
									<!-- <option value="5">Extension</option> -->
									<option value="6">Topup</option>
								</select>
							</div>
									
							<div class="col-md-3">
								<label class="control-label">Start Date:</label>
								<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchRenewedDevices()">
							</div>
							<div class="col-md-3">
								<label class="control-label">End Date:</label>
								<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchRenewedDevices()">
							</div>
									
						</div>
					</div>
				</div>
			</div>
			
			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchRenewedDevices()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-3 mb-2"></div>
							<div class="col-md-3">
								<input type="text" class="form-control" placeholder="IMEI" v-model="keyword" @keyup="fetchRenewedDevices()"/>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI & ICCID</th>
									<th>Dealer</th>
                                    <th>Recharged By</th>
                                    <th>Renewed By</th>
                                    <th>Payment By</th>
									<th>Amount</th>
									<th>Payment Type</th>
									<th>Payment Status</th>
									<th>Renewal Type</th>
									<th>Valid Until</th>
                                    <th>Action</th>
									
								</tr>
							</thead>

							<tbody v-if="Boolean(renewed_devices.length)">
								<tr v-for="(device) in renewed_devices" :key="device.id" align="center">
                                    <td>{{ device.imei }} <br> {{ device.iccid }} <br> 
										<span v-if="device.vehicle_no">Vehicle No:{{ device.vehicle_no }}</span>
									</td>
									<td>{{ device.dealer_name }}</td>
                                    <td>
										{{ device.recharged_by_name }}<br>
										{{ device.recharged_on ? $filters.formatDateTime(device.recharged_on) : '' }}
									</td>
                                    <td>
										{{ device.renewed_by_name }}<br>
										{{ device.renewed_on ? $filters.formatDateTime(device.renewed_on) : '' }}
									</td>
                                    <td>
										{{ device.paid_by_name }}<br>
										{{ device.payment_on ? $filters.formatDateTime(device.payment_on) : '' }}
									</td>
									<td>Total: {{ device.amount }} <br> 
										<span v-if="device.payment_type==4">Advance: {{ device.credit_amount }} <br></span>
										<span v-else>Cash: {{ device.cash_in_hand }} <br> Online: {{ device.cash_online }} <br> Balance: {{ device.balance_amount }}</span>
									</td>
									<td>
										<span class="badge rounded-pill bg-primary" v-if="device.payment_type==1">Cash</span>
										<span class="badge rounded-pill bg-secondary" v-if="device.payment_type==2">Online</span>
										<span class="badge rounded-pill bg-success" v-if="device.payment_type==3">Both</span>
										<span class="badge rounded-pill bg-warning" v-if="device.payment_type==4">Advance</span>
									</td>
									<td>
										<span class="badge rounded-pill bg-success" v-if="device.payment_status==1">Received</span>
                                 		<span class="badge rounded-pill bg-danger" v-if="device.payment_status==2">Not Received</span>
										 <span class="badge rounded-pill bg-warning" v-if="device.payment_status==3">Partially Received</span><br>
										<span v-if="device.payment_id != null" class="text-muted">Payment ID: {{ device.payment_id }}</span>
									</td>
									<td>
                                        <div v-if="device.is_topup==1">
                                            <span class="badge rounded-pill bg-success">Topup</span> <br>
                                        </div>
                                        <div v-else>
                                            <span class="badge rounded-pill bg-primary" v-if="device.renewal_type==1">Normal</span>
                                            <span class="badge rounded-pill bg-info" v-if="device.renewal_type==2">SIM Change</span>
                                            <span class="badge rounded-pill bg-primary" v-if="device.renewal_type==3">Replacement</span>
                                            <span class="badge rounded-pill bg-info" v-if="device.renewal_type==4">Noraml SIM Change</span>
                                            <span class="badge rounded-pill bg-secondary" v-if="device.renewal_type==5">Extension</span>
                                        </div>

                                        <span v-if="device.renewal_type== 2 || device.renewal_type== 4">
                                            <span class="badge rounded-pill bg-info" v-if="device.sim_change_status==1">Pending</span>
                                            <span class="badge rounded-pill bg-success" v-if="device.sim_change_status==2">Completed</span>
                                        </span>

                                        <span v-if="device.from_service== 1">
                                            <span class="badge rounded-pill bg-warning">From Service</span>
                                        </span>
                                    </td>
									<td>{{ device.expirationtime }} <br><br>
										<div v-if="device.is_topup==1">
                                            <span class="badge rounded-pill bg-secondary">{{ device.topup_validity }} Days</span>
                                        </div>
                                        <div v-else>
                                            <span class="badge rounded-pill bg-secondary">{{ device.certificate_validity }} Year</span>
                                        </div>
									</td>
                                    <td>
                                        <a class="btn btn-primary btn-sm mt-2 me-2 mb-2" @click="openPaymentModal(device)" v-if="device.payment_status == 2 || device.payment_status == 3">Mark As Payment Received</a>
										<a class="btn btn-warning btn-sm mt-2 me-2 mb-2" @click="openUpdateRenewalModal(device)" v-if="$canUpdateRenewalData()">Update Renewal Data</a>
										<router-link :to="{ name: 'renewal_logs', params: { id: device.id } }" class="btn btn-secondary btn-sm mt-2 me-2 mb-2">Renewal Logs</router-link>
										<div class="btn btn-info mt-2 me-2 mb-2" @click="generateCertificate(device)">Certificate</div>
										<a
											class="btn btn-danger btn-sm mt-2 me-2 mb-2"
											@click="confirmRevokeRenewedOrExtended(device)"
											v-if="$canUpdateRenewalData() && (device.renewal_type == 1 || device.renewal_type == 5) && Number(device.is_topup) !== 1"
										>
											{{ device.renewal_type == 5 ? 'Revoke Extension' : 'Revoke Renewal' }}
										</a>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
									</td>
								</tr>

							</tbody>

							<tbody v-else>
								<tr>
									<td colspan="12" align="center">No data available in the table</td>
								</tr>

							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(renewed_devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchRenewedDevices(page.url + '&limit=' + listing_length +'&keyword=' + keyword + '&from_date=' + start_date + '&to_date=' + end_date + '&renewal_type=' + renewal_type)" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav> 
					<!----pagination ends --->
                </div>

			</div>

			
		</div>

		<!-- Payment Complete Modal -->
		<div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="paymentModalLabel">Mark Payment Received</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<!-- Partial payment summary (when payment_status = 3) -->
						<div v-if="paymentModalDevice && paymentModalDevice.payment_status == 3" class="alert alert-warning mb-3">
							<h6 class="alert-heading">Partial payment details</h6>
							<p class="mb-1">Total: {{ paymentModalDevice.amount }}</p>
							<p class="mb-1">Cash paid: {{ paymentModalDevice.cash_in_hand || 0 }}</p>
							<p class="mb-1">Online paid: {{ paymentModalDevice.cash_online || 0 }}</p>
							<p class="mb-1">Advance used: {{ paymentModalDevice.credit_amount || 0 }}</p>
							<p v-if="paymentModalDevice.payment_id" class="mb-1 text-muted small">Payment ID: {{ paymentModalDevice.payment_id }}</p>
							<hr>
							<p class="mb-0 fw-bold">Balance due: {{ balanceDue }}</p>
						</div>

						<form @submit.prevent="submitPaymentComplete">
							<div class="row">
								<div class="col-md-6">
									<div class="form-group mb-3">
										<label class="control-label">Payment By<span class="text-danger">*</span></label>
										<select class="form-select" v-model="paymentForm.payment_by" @change="onPaymentByChange" :class="{ 'is-invalid': errors.payment_by }">
											<option value="">--Select Payment By--</option>
											<option value="1">Dealer</option>
											<option value="2">Customer</option>
										</select>
										<div v-if="errors.payment_by" class="invalid-feedback">{{ errors.payment_by }}</div>
									</div>
								</div>

								<div class="col-md-6" v-if="paymentForm.payment_by == '1'">
									<div class="form-group mb-3">
										<label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
										<div class="position-relative">
											<input
												class="form-control"
												type="text"
												placeholder="Search dealer..."
												v-model="paymentDealerSearch"
												@input="searchPaymentDealer"
												@focus="showPaymentDealerSuggestions = true"
												@blur="hidePaymentDealerSuggestions"
												autocomplete="off"
												:class="{ 'is-invalid': errors.payment_user_id }"
											/>
											<ul
												v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
												class="list-group position-absolute w-100"
												style="z-index: 10; max-height: 200px; overflow-y: auto;"
											>
												<li
													v-for="dealer in filteredPaymentDealers"
													:key="dealer.id"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="selectPaymentDealer(dealer)"
												>
													{{ dealer.first_name }}
												</li>
											</ul>
										</div>
										<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
									</div>
								</div>

								<div class="col-md-6" v-if="paymentForm.payment_by == '2'">
									<div class="form-group mb-3">
										<label class="control-label">Payment Customer<span class="text-danger">*</span></label>
										<div class="position-relative">
											<input
												class="form-control"
												type="text"
												placeholder="Search by name or mobile..."
												v-model="paymentCustomerSearch"
												@input="searchPaymentCustomer"
												@focus="showPaymentCustomerSuggestions = true"
												@blur="hidePaymentCustomerSuggestions"
												autocomplete="off"
												:class="{ 'is-invalid': errors.payment_user_id }"
											/>
											<ul
												v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
												class="list-group position-absolute w-100"
												style="z-index: 10; max-height: 200px; overflow-y: auto;"
											>
												<li
													v-for="cust in filteredPaymentCustomers"
													:key="cust.id"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="selectPaymentCustomer(cust)"
												>
													{{ cust.company_name }}
													<small v-if="cust.mobile" class="text-muted d-block">{{ cust.mobile }}</small>
												</li>
											</ul>
										</div>
										<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
									</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id">
								<div class="col-12">
									<div class="form-group mb-3">
										<label class="control-label">Payment type <span class="text-danger">*</span></label>
										<select class="form-select" v-model="paymentForm.payment_type" @change="onPaymentTypeChange" :class="{ 'is-invalid': errors.payment_type }">
											<option value="">-- Select --</option>
											<option value="1">Cash</option>
											<option value="2">Online</option>
											<option value="3">Both</option>
											<option value="4">Advance</option>
										</select>
										<div v-if="errors.payment_type" class="invalid-feedback d-block">{{ errors.payment_type }}</div>
									</div>
								</div>
								<div class="col-12" v-if="showUserCredit">
									<div class="form-group mb-3">
										<label class="control-label">Amount from advance<span class="text-danger">*</span></label>
										<input
											class="form-control"
											type="number"
											step="0.01"
											min="0"
											placeholder="Enter advance amount"
											v-model="paymentForm.amount_from_credit"
											:class="{ 'is-invalid': errors.amount_from_credit }"
										/>
										<div v-if="userCreditLoading" class="mt-2">
											<small class="text-success">Loading...</small>
										</div>
										<div v-else-if="userCredit && userCredit.credit_available_amount != null" class="mt-2">
											<small class="text-success">Advance available: ₹{{ userCredit.credit_available_amount }}</small>
										</div>
										<div v-else class="mt-2">
											<small class="text-muted">-</small>
										</div>
										<div v-if="errors.amount_from_credit" class="invalid-feedback d-block">{{ errors.amount_from_credit }}</div>
										<div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
									</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id && (paymentForm.payment_type == '1' || paymentForm.payment_type == '3')">
								<div class="col-12 mb-3">
									<label class="control-label">Cash amount <span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Cash amount" v-model="paymentForm.cash_in_hand" :class="{ 'is-invalid': errors.cash_in_hand }"/>
									<div v-if="errors.cash_in_hand" class="invalid-feedback d-block">{{ errors.cash_in_hand }}</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id && (paymentForm.payment_type == '2' || paymentForm.payment_type == '3')">
								<div class="col-md-6 mb-3">
									<label class="control-label">Online amount <span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Online amount" v-model="paymentForm.cash_online" :class="{ 'is-invalid': errors.cash_online }"/>
									<div v-if="errors.cash_online" class="invalid-feedback d-block">{{ errors.cash_online }}</div>
								</div>
								<div class="col-md-6 mb-3">
									<label class="control-label">Bank Account<span class="text-danger">*</span></label>
									<select class="form-select" v-model="paymentForm.bank_account_id" :class="{ 'is-invalid': errors.bank_account_id }">
										<option value="">--Select Bank--</option>
										<option v-for="bank in banks" :key="bank.id" :value="bank.id">
											{{ bank.bank_name }} ({{ bank.account_number }})
										</option>
									</select>
									<div v-if="errors.bank_account_id" class="invalid-feedback d-block">{{ errors.bank_account_id }}</div>
									<label class="control-label">Payment ID <span class="text-danger">*</span></label>
									<input class="form-control" type="text" placeholder="Payment ID" v-model="paymentForm.payment_id" :class="{ 'is-invalid': errors.payment_id }"/>
									<div v-if="errors.payment_id" class="invalid-feedback d-block">{{ errors.payment_id }}</div>
								</div>
							</div>

							<!-- Payment Breakdown Display (informational only, no validation) -->
							<div class="row" v-if="paymentBreakdown">
								<div class="col-md-12">
									<div class="card border-light">
										<div class="card-body p-2">
											<div class="row text-center">
												<div class="col-md-3">
													<small class="text-muted">Total Amount</small>
													<div class="fw-bold">₹{{ paymentBreakdown.total }}</div>
												</div>
												<div class="col-md-3" v-if="paymentForm.payment_type === '2' || paymentForm.payment_type === '3'">
													<small class="text-muted">Online</small>
													<div class="fw-bold">₹{{ paymentBreakdown.online }}</div>
												</div>
												<div class="col-md-3" v-if="paymentForm.payment_type === '1' || paymentForm.payment_type === '3'">
													<small class="text-muted">Cash</small>
													<div class="fw-bold">₹{{ paymentBreakdown.cash }}</div>
												</div>
												<div class="col-md-3">
													<small class="text-muted">Balance due</small>
													<div class="fw-bold" :class="parseFloat(balanceDue) > 0 ? 'text-warning' : 'text-success'">
														₹{{ balanceDue }}
													</div>
												</div>
												<div class="col-md-3">
													<small class="text-muted">Status</small>
													<div class="fw-bold" :class="paymentBreakdown.statusClass">
														{{ paymentBreakdown.statusLabel }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="modal-footer px-0 pb-0">
								<button type="button" class="btn btn-light" @click="closePaymentModal">Close</button>
								<button type="submit" class="btn btn-primary" :disabled="paymentSubmitting">
									<span v-if="paymentSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									{{ paymentSubmitting ? "Saving..." : "Submit" }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<UpdateRenewalDataModal
			ref="updateRenewalModal"
			modal-id="updateRenewalDataModalRenewed"
			@updated="fetchRenewedDevices(active_page_url || undefined)"
		/>

   </div>
</template>


<script>
import { Modal } from 'bootstrap'
import UpdateRenewalDataModal from '@/components/renewal/UpdateRenewalDataModal.vue'

	export default {
		name: "Renewed Devices",
		components: { UpdateRenewalDataModal },
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2024-01-01')
			const maxDate = new Date().toISOString().slice(0, 10) // Format: YYYY-MM-DD

			return {

				pagination: {},

				end_date: new Date().toISOString().slice(0, 10), // today's date (YYYY-MM-DD)
				max: maxDate,
				start_date: '',
				
				keyword: "",
				listing_length: 20,
				token: "",
				renewed_devices: [],
                type: "",
                payment_status: "",
				renewal_type: "",
				total: 0,
				excel_loading: false,

				device: 
				{
					id: "",
					user_name: "",
					payment_status: "",
				},

				pagination: {},

				complete_status: {
					id: "",
				},
				
				errors: {},

				// Payment modal
				paymentModalInstance: null,
				paymentModalDevice: null,
				paymentForm: {
					payment_type: '',
					payment_by: '',
					payment_user_id: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				},
				paymentSubmitting: false,
				userCredit: null,
				userCreditLoading: false,
				userCreditError: '',
				prevShowUserCredit: false,
				
				// Payment By selections
				dealers: [],
				paymentDealerSearch: "",
				showPaymentDealerSuggestions: false,
				selectedPaymentDealer: null,
				companies: [],
				paymentCustomerSearch: "",
				showPaymentCustomerSuggestions: false,
				selectedPaymentCustomer: null,

				// Banks
				banks: [],
				
			};
		},
		computed: {
			balanceDue() {
				if (!this.paymentModalDevice) return '0.00';
				const amount = parseFloat(this.paymentModalDevice.amount) || 0;
				const cash = parseFloat(this.paymentModalDevice.cash_in_hand) || 0;
				const online = parseFloat(this.paymentModalDevice.cash_online) || 0;
				const credit = parseFloat(this.paymentModalDevice.credit_amount) || 0;
				const balance = amount - cash - online - credit;
				return (isNaN(balance) ? 0 : balance).toFixed(2);
			},
			/** Cap for amount-from-credit vs order total / remaining balance */
			creditCapNumeric() {
				if (!this.paymentModalDevice) return NaN;
				if (Number(this.paymentModalDevice.payment_status) === 3) {
					return parseFloat(this.balanceDue) || 0;
				}
				return parseFloat(this.paymentModalDevice.amount) || 0;
			},
			showUserCredit() {
				return !!this.paymentForm.payment_user_id && this.paymentForm.payment_type === '4';
			},
			paymentBreakdown() {
				if (!this.paymentModalDevice || !this.paymentForm.payment_type || this.paymentForm.payment_type === '4') return null;

				const total = parseFloat(this.paymentModalDevice.amount) || 0;
				const online = parseFloat(this.paymentForm.cash_online) || 0;
				const cash = parseFloat(this.paymentForm.cash_in_hand) || 0;
				const outstanding = parseFloat(this.balanceDue) || 0;

				let paid = 0;
				if (this.paymentForm.payment_type === '2') {
					paid = online;
				} else if (this.paymentForm.payment_type === '3') {
					paid = online + cash;
				} else if (this.paymentForm.payment_type === '1') {
					paid = cash;
				} else {
					return null;
				}

				const eps = 0.01;
				const diff = paid - outstanding;
				let statusLabel = 'Partial';
				let statusClass = 'text-warning';
				if (Math.abs(diff) < eps) {
					statusLabel = 'Full';
					statusClass = 'text-success';
				} else if (diff > eps) {
					statusLabel = 'Advance';
					statusClass = 'text-info';
				}

				if (this.paymentForm.payment_type === '2') {
					return { total, online, cash: 0, statusLabel, statusClass };
				}
				if (this.paymentForm.payment_type === '3') {
					return { total, online, cash, statusLabel, statusClass };
				}
				return { total, online: 0, cash, statusLabel, statusClass };
			},
			filteredPaymentDealers() {
				if (!this.paymentDealerSearch.trim()) return this.dealers;
				const q = this.paymentDealerSearch.toLowerCase();
				return this.dealers.filter(d => (d.first_name || '').toLowerCase().includes(q));
			},
			filteredPaymentCustomers() {
				if (!this.paymentCustomerSearch.trim()) return this.companies;
				const q = this.paymentCustomerSearch.toLowerCase().trim();
				return this.companies.filter((c) => {
					const name = (c.company_name || "").toLowerCase();
					const mobile = String(c.mobile || "").toLowerCase();
					return name.includes(q) || mobile.includes(q);
				});
			},
		},
		watch: {
			'paymentForm.payment_user_id': 'maybeFetchUserCredit',
			'paymentForm.payment_type': 'maybeFetchUserCredit',
		},
		mounted() {
			const el = document.getElementById('paymentModal');
			if (el) this.paymentModalInstance = new Modal(el);
		this.getToken();
		this.fetchDealers();
		this.fetchCompanies();
		this.fetchBankAccounts();
		},

		created() {
			this.fetchRenewedDevices();
		},

		methods: {
			openUpdateRenewalModal(device) {
				this.$refs.updateRenewalModal?.open(device);
			},

			getSelectedUserId(entity) {
				return entity && entity.user_id ? entity.user_id : '';
			},

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchRenewedDevices(page_url = null) {
				this.getToken();
				let url = "/staffs/renewedDevices?limit=" + this.listing_length  +  "&keyword=" + this.keyword + "&from_date=" + this.start_date + "&to_date=" + this.end_date + "&renewal_type=" + this.renewal_type;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.renewed_devices = responseData.renewed_devices.data;
						this.pagination = responseData.renewed_devices.links;
						this.from = responseData.renewed_devices.from;
						this.to = responseData.renewed_devices.to;
						this.total = responseData.renewed_devices.total;
						
					})
					.catch((err) => console.log(err));
			},

			downloadRenewedDevicesExcel() {
				if (!this.start_date || !this.end_date) return;

				this.getToken();
				let page_url = "/staffs/renewedDevicesExcel?keyword=" + this.keyword + "&from_date=" + this.start_date + "&to_date=" + this.end_date + "&renewal_type=" + this.renewal_type;
				this.excel_loading = true;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
					.then((response) => {
						let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "renewed_devices_" + this.start_date + "_" + this.end_date + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(link.href);
					})
					.catch((err) => console.log(err))
					.finally(() => {
						this.excel_loading = false;
					});
			},

			confirmRevokeRenewedOrExtended(device) {
				if (!this.$canUpdateRenewalData || !this.$canUpdateRenewalData()) return;
				const label = Number(device?.renewal_type) === 5 ? 'Revoke Extension' : 'Revoke Renewal';
				this.$swal.fire({
					title: label + '?',
					html: 'This will reverse any payment, restore the previous expiration date, and reset the renewal.',
					icon: 'warning',
					position: 'center',
					input: 'textarea',
					inputLabel: 'Remarks',
					inputPlaceholder: 'Enter remarks for this revoke…',
					inputAttributes: { 'aria-label': 'Remarks' },
					inputValidator: (value) => {
						if (!value || !String(value).trim()) return 'Remarks is required';
						return null;
					},
					showCancelButton: true,
					showConfirmButton: true,
					toast: false,
					timer: undefined,
					confirmButtonText: 'Yes, revoke',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.revokeRenewedOrExtended(device, String(result.value || '').trim());
					}
				});
			},

			revokeRenewedOrExtended(device, remarks) {
				this.getToken();
				this.$axios
					.post(
						'/staffs/revokeRenewedOrExtended',
						{ device_id: device.id, remarks },
						{ headers: { Authorization: 'Bearer ' + this.token } }
					)
					.then((res) => {
						const ok = res.data?.status === true || res.data?.status === 'true';
						if (!ok) {
							this.$swal('', res.data?.message || 'Failed to revoke', 'error');
							return;
						}
						this.$swal('', res.data?.message || 'Revoked successfully', 'success');
						this.fetchRenewedDevices(this.active_page_url || undefined);
					})
					.catch((err) => {
						const msg = err?.response?.data?.message;
						this.$swal('', typeof msg === 'string' ? msg : 'Failed to revoke', 'error');
					});
			},

			generateCertificate(device) 
			{
				this.getToken();
				let page_url = "/staffs/renewelCertificate?device_id=" + device.id;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Renewal_certificate" + device.vehicle_no + ".pdf";

					const url = URL.createObjectURL(blob);

					window.open(url, "_blank");

					link.click();
						
				})
				.catch((err) => console.log(err));
			},

			openPaymentModal(device) {
				this.getToken();
				this.paymentModalDevice = device;
				this.userCredit = null;
				this.userCreditError = '';
				this.userCreditLoading = false;
				this.prevShowUserCredit = false;
				this.paymentForm = {
					payment_type: '',
					payment_by: '1',
					payment_user_id: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				};
				this.paymentDealerSearch = '';
				this.selectedPaymentDealer = null;
				this.paymentCustomerSearch = '';
				this.selectedPaymentCustomer = null;
				this.showPaymentDealerSuggestions = false;
				this.showPaymentCustomerSuggestions = false;
				this.errors = {};

				const dealerId = device?.dealer_id != null ? device.dealer_id : null;
				if (dealerId != null) {
					const dealer = this.dealers.find(
						(d) => d.id == dealerId || String(d.id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || '';
						this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = device?.dealer_name || '';
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: device?.dealer_name || '',
							user_id: device?.dealer_user_id || '',
						};
						this.paymentForm.payment_user_id =
							device?.dealer_user_id != null && device?.dealer_user_id !== ''
								? String(device.dealer_user_id)
								: '';
					}
				}

				if (this.paymentModalInstance) this.paymentModalInstance.show();
			},

			closePaymentModal() {
				if (this.paymentModalInstance) this.paymentModalInstance.hide();
				this.paymentModalDevice = null;
				this.userCredit = null;
				this.userCreditError = '';
				this.prevShowUserCredit = false;
				this.paymentForm = {
					payment_type: '',
					payment_by: '',
					payment_user_id: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				};
				this.errors = {};
			},

			onPaymentTypeChange() {
				if (this.paymentForm.payment_type === '2') {
					this.paymentForm.cash_in_hand = '';
				} else if (this.paymentForm.payment_type === '1') {
					this.paymentForm.cash_online = '';
					this.paymentForm.payment_id = '';
				} else if (this.paymentForm.payment_type === '4') {
					this.paymentForm.cash_in_hand = '';
					this.paymentForm.cash_online = '';
					this.paymentForm.payment_id = '';
				}
				if (!(this.paymentForm.payment_type === '2' || this.paymentForm.payment_type === '3')) {
					this.paymentForm.bank_account_id = '';
				}
				if (this.paymentForm.payment_type !== '4') {
					this.paymentForm.amount_from_credit = '';
				}
			},

			onPaymentByChange() {
				this.paymentForm.payment_user_id = '';
				this.paymentForm.payment_type = '';
				this.paymentForm.amount_from_credit = '';
				this.paymentForm.bank_account_id = '';
				this.selectedPaymentDealer = null;
				this.selectedPaymentCustomer = null;
				this.paymentDealerSearch = '';
				this.paymentCustomerSearch = '';
				this.errors.payment_user_id = '';
				this.userCredit = null;
				this.userCreditError = '';

				if (this.paymentForm.payment_by === '1' && this.paymentModalDevice?.dealer_id != null) {
					const dealerId = this.paymentModalDevice.dealer_id;
					const dealer = this.dealers.find(
						(d) => d.id == dealerId || String(d.id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || '';
						this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = this.paymentModalDevice?.dealer_name || '';
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: this.paymentModalDevice?.dealer_name || '',
							user_id: this.paymentModalDevice?.dealer_user_id || '',
						};
						this.paymentForm.payment_user_id =
							this.paymentModalDevice?.dealer_user_id != null &&
							this.paymentModalDevice?.dealer_user_id !== ''
								? String(this.paymentModalDevice.dealer_user_id)
								: '';
					}
				}
			},

			async maybeFetchUserCredit() {
				const nowVisible = this.showUserCredit;
				const wasVisible = this.prevShowUserCredit;

				if (!nowVisible) {
					this.userCredit = null;
					this.userCreditError = '';
					this.userCreditLoading = false;
					this.paymentForm.amount_from_credit = '';
					this.prevShowUserCredit = nowVisible;
					return;
				}
				if (!this.paymentForm.payment_user_id) return;

				if (!wasVisible) {
					const cap = this.creditCapNumeric;
					this.paymentForm.amount_from_credit =
						!isNaN(cap) && cap > 0 ? String(cap) : this.paymentModalDevice?.amount || '';
					this.errors.amount_from_credit = '';
				}

				await this.fetchUserCredit();
				this.prevShowUserCredit = nowVisible;
			},

			async fetchUserCredit() {
				try {
					this.getToken();
					this.userCreditLoading = true;
					this.userCreditError = '';

					const response = await this.$axios.get('/staffs/getUserCredit', {
						params: { user_id: this.paymentForm.payment_user_id },
						headers: { Authorization: `Bearer ${this.token}` },
					});

					const ok = response.data?.status === true || response.data?.status === 'true';
					if (!ok) {
						this.userCredit = null;
						this.userCreditError = response.data?.message || 'Failed to fetch credit balance';
						return;
					}

					this.userCredit = response.data?.data?.user_credit || null;
				} catch (e) {
					this.userCredit = null;
					this.userCreditError = e?.response?.data?.message || 'Failed to fetch credit balance';
				} finally {
					this.userCreditLoading = false;
				}
			},

			searchPaymentDealer() {
				this.showPaymentDealerSuggestions = true;
			},
			hidePaymentDealerSuggestions() {
				setTimeout(() => { this.showPaymentDealerSuggestions = false; }, 200);
			},
			selectPaymentDealer(dealer) {
				this.selectedPaymentDealer = dealer;
				this.paymentDealerSearch = dealer.first_name;
				this.showPaymentDealerSuggestions = false;
				this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
				this.errors.payment_user_id = '';
			},

			searchPaymentCustomer() {
				this.showPaymentCustomerSuggestions = true;
			},
			hidePaymentCustomerSuggestions() {
				setTimeout(() => { this.showPaymentCustomerSuggestions = false; }, 200);
			},
			selectPaymentCustomer(cust) {
				this.selectedPaymentCustomer = cust;
				this.paymentCustomerSearch = cust.company_name;
				this.showPaymentCustomerSuggestions = false;
				this.paymentForm.payment_user_id = this.getSelectedUserId(cust);
				this.errors.payment_user_id = '';
			},

			fetchDealers() {
				this.getToken();
				return this.$axios
					.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.dealers = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.dealers = [];
					});
			},

			fetchCompanies() {
				this.getToken();
				return this.$axios
					.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.companies = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.companies = [];
					});
			},

			fetchBankAccounts() {
				this.getToken();
				return this.$axios
					.get("/staffs/bankAccounts", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.banks = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.banks = [];
					});
			},

			submitPaymentComplete() {
				this.getToken();
				this.errors = {};

				if (!this.paymentForm.payment_by) {
					this.errors.payment_by = 'Please select payment by.';
				}
				if (!this.paymentForm.payment_user_id) {
					this.errors.payment_user_id = 'Please select payment user.';
				}

				const pt = this.paymentForm.payment_type;
				if (!pt) {
					this.errors.payment_type = 'Please select payment type.';
				} else if (pt === '2') {
					if (!this.paymentForm.cash_online || parseFloat(this.paymentForm.cash_online) <= 0) {
						this.errors.cash_online = 'Online amount is required.';
					}
					if (!this.paymentForm.bank_account_id) {
						this.errors.bank_account_id = 'Bank account is required for online payment.';
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
					}
				} else if (pt === '1') {
					if (!this.paymentForm.cash_in_hand || parseFloat(this.paymentForm.cash_in_hand) <= 0) {
						this.errors.cash_in_hand = 'Cash amount is required.';
					}
				} else if (pt === '3') {
					if (!this.paymentForm.cash_online || parseFloat(this.paymentForm.cash_online) <= 0) {
						this.errors.cash_online = 'Online amount is required.';
					}
					if (!this.paymentForm.cash_in_hand || parseFloat(this.paymentForm.cash_in_hand) <= 0) {
						this.errors.cash_in_hand = 'Cash amount is required.';
					}
					if (!this.paymentForm.bank_account_id) {
						this.errors.bank_account_id = 'Bank account is required for online/both payment.';
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
					}
				}

				if (this.showUserCredit) {
					const creditAmt = parseFloat(this.paymentForm.amount_from_credit);
					if (!this.paymentForm.amount_from_credit || isNaN(creditAmt) || creditAmt <= 0) {
						this.errors.amount_from_credit = 'Amount from credit is required.';
					} else {
						if (this.userCredit && this.userCredit.credit_available_amount != null) {
							const available = parseFloat(this.userCredit.credit_available_amount);
							if (!isNaN(available) && creditAmt > available) {
								this.errors.amount_from_credit = 'Amount from credit cannot exceed available credit.';
							}
						}
						const cap = this.creditCapNumeric;
						if (!isNaN(cap) && cap >= 0 && creditAmt > cap) {
							this.errors.amount_from_credit = 'Amount from credit cannot exceed the payable amount.';
						}
					}
				}

				if (Object.keys(this.errors).length) return;
				if (this.paymentSubmitting) return;

				this.paymentSubmitting = true;
				const payload = {
					device_id: this.paymentModalDevice.id,
					payment_type: parseInt(pt, 10),
					payment_user_type: this.paymentForm.payment_by,
					payment_user_id: this.paymentForm.payment_user_id,
					cash_in_hand: 0,
					cash_online: 0,
					payment_id: '',
					bank_account_id: '',
					amount_from_credit: this.showUserCredit
						? (this.paymentForm.amount_from_credit ? parseFloat(this.paymentForm.amount_from_credit) : 0)
						: 0,
				};

				if (pt === '2' || pt === '3') {
					payload.bank_account_id = this.paymentForm.bank_account_id;
					payload.cash_online = parseFloat(this.paymentForm.cash_online) || 0;
					payload.payment_id = String(this.paymentForm.payment_id).trim();
				}
				if (pt === '1' || pt === '3') {
					payload.cash_in_hand = parseFloat(this.paymentForm.cash_in_hand) || 0;
				}

				this.$axios
					.post('/staffs/paymentComplete', payload, { headers: { Authorization: 'Bearer ' + this.token } })
					.then((response) => {
						this.paymentSubmitting = false;
						if (response.data.status) {
							this.$swal('', response.data.message || 'Payment recorded successfully.', 'success');
							this.closePaymentModal();
							this.fetchRenewedDevices(this.active_page_url);
						} else {
							this.$swal('', response.data.message || 'Failed to record payment.', 'error');
						}
					})
					.catch((error) => {
						this.paymentSubmitting = false;
						const msg = error.response && error.response.data && error.response.data.message
							? error.response.data.message
							: (error.response && error.response.data && error.response.data.errors
								? Object.values(error.response.data.errors).flat().join(' ')
								: 'Something went wrong.');
						this.$swal('', msg, 'error');
						if (error.response && error.response.data && error.response.data.errors) {
							const errs = error.response.data.errors;
							this.errors = Object.keys(errs).reduce((acc, k) => {
								acc[k] = Array.isArray(errs[k]) ? errs[k][0] : errs[k];
								return acc;
							}, {});
						}
					});
			},


			
		},
	};
</script>
